var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { useQuery } from "@apollo/client";
import { letterIndexVar } from "core/state";
import { config, content } from "core/utils";
import { UserInput } from "pages/programs/UserInput";
import { ProgramOverviewGrid } from "pages/programs/components/ProgramOverviewGrid";
import { OverviewItem } from "pages/programs/utils";
import React, { useRef } from "react";
import styled from "styled-components";
import { query } from "./query";
export var AllPrograms = function (_a) {
    var userInput = _a.userInput;
    var ref = useRef(null);
    var skip = userInput.text.length >= config.search.threshold ||
        userInput.category !== "all" ||
        !!userInput.letter;
    var _b = useQuery(query, {
        skip: skip,
    }), data = _b.data, error = _b.error;
    if (!UserInput.isResultsHidden(userInput))
        return null;
    if (error || !data)
        return null;
    if (data.getFilteredOverviewItems === null)
        return null;
    if (data.getFilteredOverviewItems.items.length <= 0)
        return null;
    letterIndexVar(data.getFilteredOverviewItems.letterInfo);
    var cards = OverviewItem.toContentItemsWithDividers(data.getFilteredOverviewItems.items);
    return (React.createElement(Container, { ref: ref },
        React.createElement(ProgramOverviewGrid, { title: content.title.allPrograms, listName: "all-programs", items: cards, containerRef: ref })));
};
var Container = styled.section(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  position: relative;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var templateObject_1;
